// extracted by mini-css-extract-plugin
module.exports = {"richTextEditor":"src-components-UI-RTE-styles-style-module__richTextEditor--qQUkj"};